import { render, staticRenderFns } from "./UserIconAndSubMenu.vue?vue&type=template&id=2326d9ea&"
import script from "./UserIconAndSubMenu.vue?vue&type=script&lang=js&"
export * from "./UserIconAndSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports